import { TEmAdditionalService } from 'redux/reducers/emManagement/types';
import {
	TTableStructure,
	ETableStructureType,
	ETableStructureAlign,
	TTableStructureButton,
} from 'ui/EasTable/types';
import { DATES, DATES_ID } from 'services/constants/dates-constants';
import { EIconButtons } from 'ui/EasTable/EasTableRow/EasTableValue/constants';

export const tableStructure: TTableStructure<keyof TEmAdditionalService>[] = [
	{
		name: 'ID',
		selector: 'id',
		show: false,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.CENTER,
		// The API can return several rows with the same `id`, so compose a unique React row key.
		key: true,
		value: (item: TEmAdditionalService) =>
			[item.id, item.renewalDate, item.invoiceNumber, item.createdAt].join('-'),
	},
	{
		name: 'The recurring additional service was canceled',
		selector: 'isCanceled',
		noName: true,
		show: true,
		sortable: false,
		filterable: true,
		colSpan: 1,
		type: ETableStructureType.ICON,
		icons: [
			{
				value: true,
				icon: EIconButtons.CANCEL,
				color: 'error',
			},
		],
		align: ETableStructureAlign.CENTER,
		editable: false,
		filter: [
			['true', 'Yes'],
			['false', 'No'],
		],
		colors: [
			['true', 'error.light'],
			['false', 'warning.light'],
		],
	},

	{
		name: 'Name',
		selector: 'name',
		show: true,
		sortable: false,
		filterable: true,
		searchable: true,
		colSpan: 2,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
		editable: true,
	},
	{
		name: 'Price',
		selector: 'price',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.AMOUNT,
		align: ETableStructureAlign.RIGHT,
		editable: true,
	},

	{
		name: 'Created At',
		selector: 'createdAt',
		show: true,
		sortable: false,
		filterable: true,
		colSpan: 1,
		type: ETableStructureType.DATE,
		align: ETableStructureAlign.CENTER,
		filter: [
			[DATES_ID.TODAY, DATES.TODAY],
			[DATES_ID.YESTERDAY, DATES.YESTERDAY],
			[DATES_ID.LAST_7_DAYS, DATES.LAST_7_DAYS],
			[DATES_ID.LAST_30_DAYS, DATES.LAST_30_DAYS],
			[DATES_ID.THIS_MONTH, DATES.THIS_MONTH],
			[DATES_ID.LAST_MONTH, DATES.LAST_MONTH],
			[DATES_ID.THIS_QUARTER, DATES.THIS_QUARTER],
			[DATES_ID.LAST_QUARTER, DATES.LAST_QUARTER],
			[DATES_ID.THIS_YEAR, DATES.THIS_YEAR],
			[DATES_ID.LAST_YEAR, DATES.LAST_YEAR],
			[DATES_ID.CUSTOM_RANGE, DATES.CUSTOM_RANGE],
		],
		editable: false,
	},
	{
		name: 'Created By',
		selector: 'createdBy',
		show: true,
		sortable: false,
		filterable: true,
		colSpan: 2,
		type: ETableStructureType.USER,
		align: ETableStructureAlign.LEFT,
		editable: false,
	},

	{
		name: 'Updated At',
		selector: 'updatedAt',
		show: true,
		sortable: false,
		filterable: true,
		colSpan: 1,
		type: ETableStructureType.DATE,
		align: ETableStructureAlign.CENTER,
		filter: [
			[DATES_ID.TODAY, DATES.TODAY],
			[DATES_ID.YESTERDAY, DATES.YESTERDAY],
			[DATES_ID.LAST_7_DAYS, DATES.LAST_7_DAYS],
			[DATES_ID.LAST_30_DAYS, DATES.LAST_30_DAYS],
			[DATES_ID.THIS_MONTH, DATES.THIS_MONTH],
			[DATES_ID.LAST_MONTH, DATES.LAST_MONTH],
			[DATES_ID.THIS_QUARTER, DATES.THIS_QUARTER],
			[DATES_ID.LAST_QUARTER, DATES.LAST_QUARTER],
			[DATES_ID.THIS_YEAR, DATES.THIS_YEAR],
			[DATES_ID.LAST_YEAR, DATES.LAST_YEAR],
			[DATES_ID.CUSTOM_RANGE, DATES.CUSTOM_RANGE],
		],
		editable: false,
	},
	{
		name: 'Updated By',
		selector: 'updatedBy',
		show: true,
		sortable: false,
		filterable: true,
		colSpan: 2,
		type: ETableStructureType.USER,
		align: ETableStructureAlign.LEFT,
		editable: false,
	},

	{
		name: 'Service ID',
		selector: 'serviceId',
		show: false,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.CENTER,
		editable: false,
	},

	{
		name: 'Recurring',
		selector: 'isRecurring',
		show: true,
		sortable: false,
		filterable: true,
		colSpan: 1,
		type: ETableStructureType.BOOLEAN,
		align: ETableStructureAlign.CENTER,
		filter: [
			['true', 'Yes'],
			['false', 'No'],
		],
		colors: [
			['true', 'success.light'],
			['false', 'warning.light'],
		],
		editable: true,
	},

	{
		name: 'Service Period, months',
		selector: 'servicePeriod',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.CENTER,
		editable: true,
	},

	{
		name: 'Renewal Date',
		selector: 'renewalDate',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.DATE,
		align: ETableStructureAlign.CENTER,
	},

	{
		name: 'Included Into Invoice',
		selector: 'includedIntoInvoice',
		show: false,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.CENTER,
	},
	{
		name: 'Invoice Number',
		selector: 'invoiceNumber',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.CENTER,
		editable: false,
	},
	{
		name: 'Invoice Date',
		selector: 'invoiceDate',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.DATE,
		align: ETableStructureAlign.CENTER,
		editable: false,
	},

	{
		name: 'Invoice Status',
		selector: 'invoiceStatus',
		show: true,
		sortable: false,
		filterable: true,
		filter: [
			['pending', 'pending'],
			['paid', 'paid'],
			['partially_paid', 'partially paid'],
		],
		colors: [
			['pending', 'warning.light'],
			['paid', 'success.light'],
			['partially_paid', 'info.light'],
		],
		colSpan: 1,
		type: ETableStructureType.STATUS,
		align: ETableStructureAlign.LEFT,
		editable: false,
	},

	{
		name: 'Actions',
		selector: 'id',
		noName: true,
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.BUTTONS,
		align: ETableStructureAlign.LEFT,
		buttonFilter: (item: TEmAdditionalService) => {
			const buttons: TTableStructureButton[] = [];
			if (!item.includedIntoInvoice) {
				buttons.push(
					{
						name: 'Generate Invoice',
						icon: EIconButtons.RECEIPT,
					},
					{
						name: 'Edit',
						icon: EIconButtons.EDIT,
					},
				);
			} else {
				buttons.push({
					name: 'Download Invoice',
					icon: EIconButtons.DOWNLOAD,
				});
				if (item.isRecurring && !item.isCanceled) {
					buttons.push({
						name: 'Cancellation of the recurring additional service',
						icon: EIconButtons.CANCEL,
					});
				}
			}
			return buttons;
		},
	},
];
